export const Variables = {
    color: {
        black: '#000',
        primary: '#222222',
        cocoa: '#14323C',
        warmGrey: '#B8AD9E',
        lightGrey: '#EFE9DA',
        border: '#807770',
        red: '#D55961',
        white: '#FFFFFF',
        pink: '#FFDCC8',
        gold: '#C8965A'
    },
    font: {
        body: `'MessinaSans', serif`,
        title: `'Roman Grotesque', serif`,
        button: `'MessinaSans', sans-serif`,
        bodyBold: `'MessinaSansBold' , sans-serif`
    },
}
